export const PORT_OPERATOR_LICENSE_REQUEST_FIELDS = {
  COMPANY_NAME: "companyName",
  COMPANY_NAME_ARABIC: "companyNameArabic",
  COMPANY_TYPES: "companyTypes",
  COMPANY_ADDRESS: "companyAddress",
  TELEPHONE_NUMBER: "telephoneNumber",
  MOBILE_NUMBER: "mobileNumber",
  FAX_NUMBER: "faxNumber",
  COMPANY_EMAIL: "companyEmail",
  APPLICANT_EMAIL: "applicantEmail",
  APPLICANT_NAME: "applicantName",
  APPLICANT_POSITION: "applicantPosition",
  NATURE_OF_BUSINESS_IN_POF: "natureOfBusinessInPof",
  NUMBER_OF_EMPLOYEES: "numberOfEmployees",
  NUMBER_OF_VEHICLES: "numberOfVehicles",
  TRADING_LICENSE_NUMBER: "tradingLicenseNumber",
  TRADING_LICENSE_VALIDITY_DATE: "tradingLicenseValidityDate",
  TRADE_LICENSE_ISSUING_AUTHORITY: "tradeLicenseIssuingAuthority",
  PURPOSE_OF_REQUEST: "purposeOfRequest",
  TRADE_LICENSE_DOCUMENT_URL: "tradeLicenseDocumentUrl",
  PORT_OPERATOR_LICENSE_DOCUMENT_URL: "portOperatorLicenseDocumentUrl",
  OTHERS_DOCUMENT_URL: "othersDocumentUrl",
  FUJAIRAH_REGISTERED_COMPANY: "fujairahRegisteredCompany",
} as const;
